<template>
	<div style="font-size: 14px; padding: 5px 5px" class="child_pages">
		<div
			v-if="
				show_active_project == false &&
				showCreateTaskPage == false &&
				active_view != 'CREATE_PROJECT' &&
				active_view != 'CREATE_TASK' &&
				active_view != 'EDIT_PROJECT' &&
				show_add_form == false &&
				active_view != 'VIEW_QUESTIONS' &&
				active_view != 'RAISE_TICKET' &&
				active_view != 'VIEW_QUESTIONS_SECTION' &&
				show_list_action_page == '1' &&
				view_type == '1' &&
				!hide_top_tab &&
				active_view != 'VIEW_QUESTIONS_DETAILS'
			"
		>
			<el-row>
				<el-col :span="24">
					<el-card shadow="none">
						<span v-for="(item, idx) in childPagesItems" :key="idx">
							<span
								@click="changeChildPage(idx, item)"
								style="margin-right: 40px; cursor: pointer"
								:style="item.active ? 'font-weight:bold' : ''"
								>{{ item.name }}</span
							>
						</span>
					</el-card>
				</el-col>
			</el-row>
			<div v-if="active_view == 'PROJECT'">
				<el-row style="margin-top: 30px; margin-left: 20px">
					<span v-for="(item, idx) in projectPagesItems" :key="idx">
						<span
							@click="changeProjectPage(idx)"
							style="margin-right: 40px; cursor: pointer"
							:style="item.active ? 'font-weight:bold' : ''"
							>{{ item.name }}</span
						>
					</span>
				</el-row>
				<div style="margin-top: 20px" v-if="projectPagesItems[0].active">
					<el-row>
						<el-col :span="6">
							<div>Location</div>
							<el-select
								@change="get_res_by_location(0, 'project')"
								style="margin-top: 10px"
								class="select"
								v-model="locations"
								filterable
								placeholder="Select Locations"
							>
								<el-option
									v-for="(item, key) in locationItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4" :offset="1">
							<div>Date</div>
							<el-date-picker
								style="margin-top: 10px"
								v-model="active_date"
								type="date"
								placeholder="Select Date"
								class="date"
								format="yyyy-MM-dd"
								:picker-options="datePickerOptions"
							>
							</el-date-picker>
						</el-col>
						<el-col style="margin-top: 23px" :span="5" :offset="1">
							<el-input
								type="text"
								v-model="search"
								placeholder="Search Projects & Tasks"
								suffix-icon="el-icon-search"
								class="input-class"
							/>
						</el-col>
					</el-row>
					<el-row
						v-loading="isloading"
						class="project-table"
						style="margin-top: 14px"
					>
						<el-col :span="24">
							<el-table
								:data="
									tableDataActive

										.filter(
											(el) =>
												!selected_Active_project.length ||
												selected_Active_project.includes(el.project_name)
										)
										.filter(
											(el) =>
												!selected_Frequency_project.length ||
												selected_Frequency_project.includes(el.frequency)
										)
										.filter(
											(el) =>
												!search ||
												el.project_name
													.toLowerCase()
													.includes(search.toLowerCase())
										)
										.filter(
											(el, index) =>
												index >= startNumber - 1 && index < endNumber
										)
								"
							>
								<el-table-column label="Project">
									<template slot="header" slot-scope="scope">
										Projects & Tasks
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_form_name"
												size="mini"
												placeholder="Search "
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_Active_project">
													<el-checkbox
														v-for="(formItem, index) in uniqueFormNames.filter(
															(el) =>
																!searched_form_name ||
																el
																	.toLowerCase()
																	.includes(searched_form_name.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="formItem"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="
														selected_Active_project = [...uniqueFormNames]
													"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_Active_project = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_Active_project.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
									<template slot-scope="scope">
										<div
											@click="get_active_project_details(scope.row, null, '5')"
											style="
												color: #ff8732;
												cursor: pointer;
												word-break: break-word;
												line-height: 120%;
											"
										>
											<u>{{ scope.row.project_name }}</u>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Frequency">
									<template slot="header" slot-scope="scope">
										Frequency
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_Frequency_name"
												size="mini"
												placeholder="Search Frequency"
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_Frequency_project">
													<el-checkbox
														v-for="(
															formItem, index
														) in uniqueFrequencyNames.filter(
															(el) =>
																!searched_Frequency_name ||
																el
																	.toLowerCase()
																	.includes(
																		searched_Frequency_name.toLowerCase()
																	)
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="formItem"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="
														selected_Frequency_project = [
															...uniqueFrequencyNames,
														]
													"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_Frequency_project = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_Frequency_project.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
									<template slot-scope="scope">
										<div style="text-transform: capitalize">
											{{ scope.row.frequency }}
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Start Date">
									<template slot-scope="scope">
										{{ moment(scope.row.start_date).format("Do MMM YYYY") }}
									</template>
								</el-table-column>
								<el-table-column label="Due Date">
									<template slot-scope="scope">
										{{ moment(scope.row.end_date).format("Do MMM YYYY") }}
									</template>
								</el-table-column>
								<el-table-column label="User">
									<template slot-scope="scope">
										<div style="font-size: 10px; margin-top: -5px">
											<span style="word-break: break-word; line-height: 120%">{{
												scope.row.full_name
											}}</span>
											<div
												style="
													word-break: break-word;
													line-height: 120%;
													color: #d26300;
													text-align: center;
												"
											>
												{{ scope.row.designation_name }}
											</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Status">
									<template slot-scope="scope">
										<el-tag
											size="small"
											style="
												border-radius: 12px;
												width: 80px;
												text-align: center;
											"
											:style="
												scope.row.task_status_update_info.status != 'inprogress'
													? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
													: 'border-color:#D26300; background-color:#FFF9F4; color:#D26300'
											"
											>{{
												scope.row.task_status_update_info.status != "inprogress"
													? "Completed"
													: "In progress"
											}}
										</el-tag>
									</template>
								</el-table-column>
								<!-- <el-table-column show-overflow-tooltip>
									<template slot-scope="scope">
										<img
											width="15px"
											class="mr-5"
											src="../../../../assets/images/download.png"
										/>
									</template>
								</el-table-column> -->
							</el-table>
						</el-col>
					</el-row>
					<el-row :gutter="10" class="mt-3">
						<el-col :span="8" class="text-left">
							<div>
								<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
								{{ tableDataActive.length }} results
							</div>
						</el-col>
						<el-col :span="8" class="text-center">
							<el-select
								v-model="perPage"
								name="per_page"
								placeholder="select per page"
								style="width: 90px !important"
								size="mini"
							>
								<el-option label="10" :value="10"></el-option>
								<el-option label="25" :value="25"></el-option>
								<el-option label="50" :value="50"></el-option>
								<el-option label="100" :value="100"></el-option>
							</el-select>
							&nbsp;<b>per page</b>
						</el-col>
						<el-col :span="8" class="text-right">
							<el-pagination
								background
								layout="prev, pager, next"
								:total="tableDataActive.length"
								:page-size="perPage"
								:current-page.sync="currentPage"
							></el-pagination>
						</el-col>
					</el-row>
				</div>
				<div
					style="margin-top: 30px"
					v-if="
						projectPagesItems[1].active &&
						this.company_details.access_level == 'admin'
					"
				>
					<el-row>
						<el-col :span="5">
							<el-input
								type="text"
								v-model="search_projects"
								placeholder="Search Projects & Tasks"
								suffix-icon="el-icon-search"
								class="input-class"
							/>
						</el-col>
						<el-col :span="2" style="margin-top: -40px" :offset="16">
							<!-- <el-button
								@click="create_project()"
								class="button-class"
								icon="el-icon-circle-plus-outline"
							>
								Create Project
							</el-button> -->
							<!-- <el-popover
								style="
									overflow-x: auto;
									overflow-y: auto;
									padding: 0;
									margin: 0;
								"
								placement="bottom"
								width="160"
								v-model="visible"
							>
								<ul
									style="
										list-style-type: none;
										text-align: center;
										padding: 0;
										margin-top: 5px;
									"
								>
									<li
										@click="create_project()"
										style="cursor: pointer; height: 30px"
									>
										Create Project
									</li>
									<li
										@click="create_task()"
										style="cursor: pointer; height: 30px"
									>
										Create Task
									</li>
								</ul>
								<el-button
									class="button-class"
									icon="el-icon-circle-plus-outline"
									slot="reference"
									>Create</el-button
								>
							</el-popover> -->
							<el-popover
								style="max-width: 200px"
								placement="bottom"
								width="160"
								v-model="visible"
							>
								<ul class="popover-menu">
									<li @click="create_project">Create Project</li>
									<li @click="create_task">Create Task</li>
								</ul>
								<el-button
									class="button-class"
									icon="el-icon-circle-plus-outline"
									slot="reference"
								>
									Create
								</el-button>
							</el-popover>
						</el-col>
					</el-row>
					<el-row
						style="margin-top: 30px"
						v-loading="isloading"
						class="project-table"
					>
						<el-col :span="24">
							<el-table
								fixed
								:data="
									tableData

										.filter(
											(el) =>
												!selected_Manage_project.length ||
												selected_Manage_project.includes(el.project_info.name)
										)
										.filter(
											(el) =>
												!selected_Frequency_Manage.length ||
												selected_Frequency_Manage.includes(el.frequency)
										)
										.filter(
											(el) =>
												!search_projects ||
												el.project_info.name
													.toLowerCase()
													.includes(search_projects.toLowerCase())
										)
										.filter(
											(el, index) =>
												index >= startNumberManage - 1 &&
												index < endNumberManage
										)
								"
							>
								<el-table-column width="500px" label="Project">
									<template slot="header" slot-scope="scope">
										Projects & Tasks
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_Manage_name"
												size="mini"
												placeholder="Search "
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_Manage_project">
													<el-checkbox
														v-for="(
															formItem, index
														) in uniqueManageProjectNames.filter(
															(el) =>
																!searched_Manage_name ||
																el
																	.toLowerCase()
																	.includes(searched_Manage_name.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="formItem"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="
														selected_Manage_project = [
															...uniqueManageProjectNames,
														]
													"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_Manage_project = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_Manage_project.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
									<template slot-scope="scope">
										<div
											@click="edit_project_method(scope.$index, scope.row)"
											style="
												color: #ff8732;
												word-break: break-word;
												line-height: 120%;
											"
										>
											<u>{{ scope.row.project_info.name }}</u>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Locations">
									<template slot-scope="scope">
										<div style="word-break: break-word; line-height: 120%">
											{{ scope.row.locations.length }} Locations
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="assign_to" label="Assigned To">
									<template slot-scope="scope">
										<el-popover
											placement="right-start"
											title="Designation List"
											width="300"
											trigger="hover"
										>
											<div
												slot="reference"
												style="word-break: break-word; line-height: 120%"
												v-text="
													`${
														scope.row.designations_list.length == 0
															? '-'
															: scope.row.designations_list.length == 1
															? scope.row.designations_list[0]
															: scope.row.designations_list[0] +
															  ' +' +
															  (scope.row.designations_list.length - 1)
													}`
												"
											></div>
											<div
												v-for="(item, idx) in scope.row.designations_list"
												:key="idx"
											>
												{{ item }} <br />
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column label="Frequency">
									<template slot="header" slot-scope="scope">
										Frequency
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_Frequency_Manage"
												size="mini"
												placeholder="Search Frequency"
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_Frequency_Manage">
													<el-checkbox
														v-for="(
															formItem, index
														) in uniqueFrequencyNamesManage.filter(
															(el) =>
																!searched_Frequency_Manage ||
																el
																	.toLowerCase()
																	.includes(
																		searched_Frequency_Manage.toLowerCase()
																	)
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="formItem"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="
														selected_Frequency_Manage = [
															...uniqueFrequencyNamesManage,
														]
													"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_Frequency_Manage = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_Frequency_Manage.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
									<template slot-scope="scope">
										<div style="text-transform: capitalize">
											{{ scope.row.frequency }}
										</div>
									</template>
								</el-table-column>
								<!-- <el-table-column prop="validity_start_date" label="Start Date">
									<template slot-scope="scope">
										{{
											moment(scope.row.validity_start_date).format(
												"Do MMM YYYY"
											)
										}}
									</template>
								</el-table-column> -->
								<!-- <el-table-column label="Due Date">
									<template slot-scope="scope">
										<div>
											{{
												scope.row.validity_never_ends
													? "-"
													: moment(scope.row.validity_end_date).format(
															"Do MMM YYYY"
													  )
											}}
										</div>
									</template>
								</el-table-column> -->
								<el-table-column
									prop="created_by_info.full_name"
									label="Created By"
								>
								</el-table-column>
								<!-- <el-table-column label="Status">
									<template slot-scope="scope">
										<el-tag
											size="small"
											style="
												border-radius: 12px;
												width: 70px;
												text-align: center;
											"
											:style="
												scope.row.execution_type == 'project'
													? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
													: 'border-color:#D26300; background-color:#FFF9F4; color:#D26300'
											"
											>{{
												scope.row.execution_type == "project"
													? "Active"
													: "Draft"
											}}
										</el-tag>
									</template>
								</el-table-column> -->
								<el-table-column show-overflow-tooltip>
									<template slot-scope="scope">
										<img
											@click="edit_project_method(scope.$index, scope.row)"
											width="15px"
											class="mr-5"
											src="../../../../assets/icons/EditIcon.png"
											style="cursor:pointer"
										/>
										<img
										v-if="company_details.access_level == 'admin'"
										style="cursor:pointer"
											@click="
												delete_manage_projects_method(scope.$index, scope.row)
											"
											width="13px"
											src="../../../../assets/icons/Union.png"
										/>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row :gutter="10" class="mt-3">
						<el-col :span="8" class="text-left">
							<div>
								<b>Showing</b> {{ startNumberManage }} to
								{{ endNumberManage }} of {{ tableData.length }} results
							</div>
						</el-col>
						<el-col :span="8" class="text-center">
							<el-select
								v-model="perPageManage"
								name="per_page"
								placeholder="select per page"
								style="width: 90px !important"
								size="mini"
							>
								<el-option label="10" :value="10"></el-option>
								<el-option label="25" :value="25"></el-option>
								<el-option label="50" :value="50"></el-option>
								<el-option label="100" :value="100"></el-option>
							</el-select>
							&nbsp;<b>per page</b>
						</el-col>
						<el-col :span="8" class="text-right">
							<el-pagination
								background
								layout="prev, pager, next"
								:total="tableData.length"
								:page-size="perPageManage"
								:current-page.sync="currentPageManage"
							></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div v-if="show_active_project">
			<el-row>
				<el-col :span="1">
					<img
						@click="show_active_project = false"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div @click="show_active_project = false">Back</div>
				</el-col>
			</el-row>
			<el-row style="margin-top: 10px">
				<el-col :span="12">
					<!-- <div>Location</div> -->
					<!-- <el-select
						@change="get_res_by_location(1, 'project')"
						style="margin-top: 10px"
						class="select"
						v-model="locations"
						filterable
						placeholder="Select Locations"
					>
						<el-option
							v-for="(item, key) in locationItems"
							:key="key"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select> -->

					<div style="display: flex">
						<div
							style="
								margin-top: 15x;
								font-size: 14px;
								font-weight: bold;
								margin-left: 5px;
								text-transform: capitalize;
							"
						>
							{{ locationItems.filter((el) => el.id == locations)[0].name }} (
							{{ project_info_object.project_name }} )
						</div>
						<div style="margin-left: 30px">
							<div
								v-if="
									project_info_object.execution_setup_info
										.project_sign_off_required
								"
								style="
									display: flex;
									justify-content: flex-end;
									margin-right: 50px;
									text-decoration: underline;
									color: #d26300;
									cursor: pointer;
								"
								@click="projectReview()"
							>
								Project Review
							</div>
						</div>
					</div>
				</el-col>
				<!-- Refresh button -->
				<el-col
					v-if="project_info_object.frequency === 'anytime'"
					style="margin-top: 0px"
					:span="4"
				>
					<el-button
						class="button-class-2"
						size="mini"
						style="float: right; margin-right: 10px"
						@click="cal_launch_api()"
					>
						Add New
					</el-button>
				</el-col>
				<!-- Refresh button -->
				<el-col style="margin-top: 0px" :span="5">
					<el-input
						type="text"
						v-model="search_form"
						placeholder="Search Form"
						suffix-icon="el-icon-search"
						class="input-class"
					/>
				</el-col>
				<!-- <el-col :span="4" style="margin-left: 30px">
					<div>Date</div>
					<el-date-picker
						style="margin-top: 10px"
						v-model="active_date"
						type="date"
						placeholder="Select Date"
						class="date"
						format="yyyy-MM-dd"
					>
					</el-date-picker>
				</el-col> -->
			</el-row>
			<el-row style="margin-top: 10px; margin-left: 10px">
				<span v-for="(item, idx) in tableDataActiveCategory" :key="idx">
					<div
						@click="change_active_category(idx, item)"
						style="
							margin-top: 5px;
							color: black;
							margin-right: 20px;
							cursor: pointer;
							text-transform: capitalize;
						"
						:style="item.active ? 'font-weight: 600' : 'font-weight:normal'"
					>
						{{ item.form_category_info.name }}
						<!-- <div
							style="
								margin-top: 5px;
								color: #d26300;
								font-size: 12px;
								text-align: center;
							"
						>
							Steps -
							{{ item.task_status_update_info.completed }} /
							{{ item.task_status_update_info.total }} completed
						</div> -->
					</div>
				</span>
			</el-row>
			<el-row v-loading="isloading" style="margin-top: 10px">
				<el-col :span="24">
					<el-row class="project-table-category5" style="margin-top: 5px">
						<el-col :span="24">
							<el-table
								:data="
									tableDataActiveSectionAbout.filter(
										(el) =>
											!search_form ||
											el.form_info.name
												.toLowerCase()
												.includes(search_form.toLowerCase())
									)
								"
							>
								<el-table-column label="Form">
									<template slot-scope="scope">
										<div
											@click="getQuestionsOfForm(scope.row, scope.$index)"
											style="margin-top: -5px; color: #d26300; cursor: pointer"
										>
											<u>{{ scope.row.form_info.name }}</u>
											<div style="margin-top: -5px; color: black">
												Steps -
												{{
													scope.row.task_status_update_info.completed != null
														? scope.row.task_status_update_info.completed
														: 0
												}}
												/
												{{ scope.row.task_status_update_info.total }} completed
											</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Points">
									<template slot-scope="scope">
										<div style="margin-top: -5px">
											{{
												scope.row.task_status_update_info.current_score != null
													? scope.row.task_status_update_info.current_score
													: 0
											}}
											/
											{{ scope.row.task_status_update_info.total_score }}
											points
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Status">
									<template slot-scope="scope">
										<el-tag
											size="small"
											style="
												border-radius: 12px;
												width: 80px;
												text-align: center;
											"
											:style="
												scope.row.task_status_update_info.status != 'inprogress'
													? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
													: 'border-color:#D26300; background-color:#FFF9F4; color:#D26300'
											"
											>{{
												scope.row.task_status_update_info.status != "inprogress"
													? "Completed"
													: "In progress"
											}}
										</el-tag>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row style="margin-top: 30px">
				<el-col :span="24">
					<el-card style="border-radius: 12px; height: 40px" shadow="none">
						<el-row style="margin-top: -10px">
							<el-col :span="10">
								<span style="font-weight: bold; font-size: 16px">
									<u>{{ project_info_name }}</u>
									<span
										style="color: #ff8732; margin-left: 20px; font-size: 14px"
										>{{ project_info_status }}
									</span>
								</span>
							</el-col>
							<el-col :span="4">
								<el-button
									icon="el-icon-collection"
									style="margin-top: -15px; height: 30px"
									class="button-class"
									size="mini"
									@click="submit_form_condition_check()"
									:disabled="
										project_info_object.task_status_update_info.status ==
											'inprogress' || project_info_object.is_submitted == true
									"
								>
									Submit Project
								</el-button>
								<!-- 
									
									
									
									&&
										show_buttons !== false -->
							</el-col>
							<el-col :span="3" :offset="7">
								<div
									style="cursor: pointer"
									@click="show_category_card = !show_category_card"
								>
									View Summary
									<img
										v-if="show_category_card"
										width="10px"
										style="margin-left: 20px"
										src="../../../../assets/icons/VectorUp.png"
									/>
									<img
										v-if="show_category_card == false"
										width="10px"
										style="margin-left: 20px"
										src="../../../../assets/icons/Vector.png"
									/>
								</div>
							</el-col>
						</el-row>
					</el-card>
				</el-col>
			</el-row>
			<div v-if="show_category_card">
				<el-row style="margin-top: 5px">
					<el-col :span="24">
						<div
							style="border: 1px solid; border-color: #e2e5ea"
							class="mx-4"
						></div>
					</el-col>
				</el-row>
				<el-row class="project-table-category55" style="margin-top: 5px">
					<el-col :span="24">
						<el-table :data="tableDataActiveCategory">
							<el-table-column label="Category" show-overflow-tooltip>
								<template slot-scope="scope">
									<div
										style="font-size: 12px; margin-top: -5px; color: #d26300"
									>
										{{ scope.row.form_category_info.name }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Forms">
								<template slot-scope="scope">
									<div style="margin-top: -5px">
										{{
											scope.row.task_status_update_info.completed != null
												? scope.row.task_status_update_info.completed
												: 0
										}}
										/ {{ scope.row.task_status_update_info.total }} completed
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Completion %">
								<template slot-scope="scope">
									<div style="margin-top: -5px">
										{{
											(scope.row.task_status_update_info.completed != null
												? (scope.row.task_status_update_info.completed /
														scope.row.task_status_update_info.total) *
												  100
												: 0
											).toFixed(2)
										}}
										%
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Score">
								<template slot-scope="scope">
									<div style="margin-top: -5px">
										{{
											scope.row.task_status_update_info.current_score != null
												? scope.row.task_status_update_info.current_score
												: 0
										}}
										/
										{{ scope.row.task_status_update_info.total_score }}
										points
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Score %">
								<template slot-scope="scope">
									<div style="margin-top: -5px">
										{{ (scope.row.total_score * 100).toFixed(2) }}
										%
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Critical">
								<template slot-scope="scope">
									<div>
										{{
											scope.row.task_status_update_info.is_critical_triggered
												? "Pass"
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row
					v-if="tableDataActiveCategory.length >= 1"
					class="project-table-category55"
					style="margin-top: 0px; border-radius: 12px"
				>
					<el-col :span="24">
						<el-table
							empty-text=""
							style="border-radius: 8px"
							:data="tableData1"
						>
							<el-table-column label="Total"> </el-table-column>
							<el-table-column :label="getFormsTotal"> </el-table-column>
							<el-table-column :label="getCompletionTotal"> </el-table-column>
							<el-table-column :label="getScoreTotal"> </el-table-column>
							<el-table-column :label="getCompletionScoreTotal">
							</el-table-column>
							<el-table-column label="-"> </el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</div>
		</div>
		<div v-if="active_view == 'TASK' && showCreateTaskPage == false">
			<el-row style="margin-top: 30px; margin-left: 20px">
				<span v-for="(item, idx) in taskPagesItems" :key="idx">
					<span
						@click="changeTaskPage(idx)"
						style="margin-right: 40px; cursor: pointer"
						:style="item.active ? 'font-weight:bold' : ''"
						>{{ item.name }}</span
					>
				</span>
			</el-row>
			<div style="margin-top: 20px" v-if="taskPagesItems[0].active">
				<el-row>
					<el-col :span="6">
						<div>Location</div>
						<el-select
							@change="get_res_by_location(1, 'standalone')"
							style="margin-top: 10px"
							class="select"
							v-model="locations"
							filterable
							placeholder="Select Locations"
						>
							<el-option
								v-for="(item, key) in locationItems"
								:key="key"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
					</el-col>
					<!-- <el-col :span="4" :offset="1">
						<div>Date</div>
						<el-date-picker
							style="margin-top: 10px"
							v-model="start_date"
							type="date"
							placeholder="Select Date"
							class="date"
							format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-col> -->
					<el-col style="margin-top: 23px" :span="5" :offset="1">
						<el-input
							type="text"
							v-model="search_active_task"
							placeholder="Search Tasks"
							suffix-icon="el-icon-search"
							class="input-class"
						/>
					</el-col>
				</el-row>
				<el-row class="project-table" style="margin-top: 14px">
					<el-col :span="24">
						<el-table
							:data="
								tableDataActiveTask

									.filter(
										(el) =>
											!selected_Active_Task.length ||
											selected_Active_Task.includes(el.project_name)
									)
									.filter(
										(el) =>
											!selected_Frequency_Active_Task.length ||
											selected_Frequency_Active_Task.includes(el.frequency)
									)
									.filter(
										(el) =>
											!search_active_task ||
											el.project_name
												.toLowerCase()
												.includes(search_active_task.toLowerCase())
									)
									.filter(
										(el, index) =>
											index >= startNumberActiveTask - 1 &&
											index < endNumberActiveTask
									)
							"
						>
							<el-table-column width="500px" label="Task">
								<template slot="header" slot-scope="scope">
									Task
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_form_name"
											size="mini"
											placeholder="Search Task"
										></el-input>
										<div
											style="
												max-height: 250px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Active_Task">
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueActiveTaskProjectNames.filter(
														(el) =>
															!searched_form_name ||
															el
																.toLowerCase()
																.includes(searched_form_name.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="
													selected_Active_Task = [
														...uniqueActiveTaskProjectNames,
													]
												"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Active_Task = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Active_Task.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div
										@click="get_active_project_details(scope.row)"
										style="
											color: #ff8732;
											cursor: pointer;
											word-break: break-word;
											line-height: 120%;
										"
									>
										<u>{{ scope.row.project_name }}</u>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Frequency">
								<template slot="header" slot-scope="scope">
									Frequency
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Frequency_Active_Task"
											size="mini"
											placeholder="Search Frequency"
										></el-input>
										<div
											style="
												max-height: 250px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group
												v-model="selected_Frequency_Active_Task"
											>
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueFrequencyActiveTaskNames.filter(
														(el) =>
															!searched_Frequency_Active_Task ||
															el
																.toLowerCase()
																.includes(
																	searched_Frequency_Active_Task.toLowerCase()
																)
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="
													selected_Frequency_Active_Task = [
														...uniqueFrequencyActiveTaskNames,
													]
												"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Frequency_Active_Task = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Frequency_Active_Task.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div style="text-transform: capitalize">
										{{ scope.row.frequency }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Start Date">
								<template slot-scope="scope">
									{{ moment(scope.row.start_date).format("Do MMM YYYY") }}
								</template>
							</el-table-column>
							<el-table-column label="Due Date">
								<template slot-scope="scope">
									{{ moment(scope.row.end_date).format("Do MMM YYYY") }}
								</template>
							</el-table-column>
							<el-table-column label="User">
								<template slot-scope="scope">
									<div style="font-size: 10px; margin-top: -5px">
										<span style="word-break: break-word; line-height: 120%">{{
											scope.row.full_name
										}}</span>
										<div
											style="
												word-break: break-word;
												line-height: 120%;
												color: #d26300;
												text-align: center;
											"
										>
											{{ scope.row.designation_name }}
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Status">
								<template slot-scope="scope">
									<el-tag
										size="small"
										style="border-radius: 12px; width: 70px; text-align: center"
										:style="
											scope.row.status != 'Draft'
												? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
												: 'border-color:#D26300; background-color:#FFF9F4; color:#D26300'
										"
										>{{ scope.row.status != "Draft" ? "Active" : "Draft" }}
									</el-tag>
								</template>
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip>
									<template slot-scope="scope">
										<img
											width="15px"
											class="mr-5"
											src="../../../../assets/images/download.png"
										/>
									</template>
								</el-table-column> -->
						</el-table>
					</el-col>
				</el-row>
				<el-row :gutter="10" class="mt-3">
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumberActiveTask }} to
							{{ endNumberActiveTask }} of
							{{ tableDataActiveTask.length }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPageActiveTask"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="tableDataActiveTask.length"
							:page-size="perPageActiveTask"
							:current-page.sync="currentPageActiveTask"
						></el-pagination>
					</el-col>
				</el-row>
			</div>
			<div style="margin-top: 30px" v-if="taskPagesItems[1].active">
				<el-row>
					<el-col :span="5">
						<el-input
							type="text"
							v-model="search_Manage_task"
							placeholder="Search Tasks"
							suffix-icon="el-icon-search"
							class="input-class"
						/>
					</el-col>
					<el-col style="margin-top: -40px" :span="2" :offset="16">
						<el-button
							@click="show_create_task_page()"
							class="button-class"
							icon="el-icon-circle-plus-outline"
						>
							Create Task
						</el-button>
					</el-col>
				</el-row>
				<el-row class="project-table" style="margin-top: 14px">
					<el-col :span="24">
						<el-table
							:data="
								tableDataTask

									.filter(
										(el) =>
											!selected_Manage_Task.length ||
											selected_Manage_Task.includes(el.project_info.name)
									)
									.filter(
										(el) =>
											!selected_Frequency_Manage_Task.length ||
											selected_Frequency_Manage_Task.includes(el.frequency)
									)
									.filter(
										(el) =>
											!search_Manage_task ||
											el.project_info.name
												.toLowerCase()
												.includes(search_Manage_task.toLowerCase())
									)
									.filter(
										(el, index) =>
											index >= startNumberManageTask - 1 &&
											index < endNumberManageTask
									)
							"
						>
							<el-table-column label="Task">
								<template slot="header" slot-scope="scope">
									Task
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Task_name"
											size="mini"
											placeholder="Search Task"
										></el-input>
										<div
											style="
												max-height: 250px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Manage_Task">
												<el-checkbox
													v-for="(
														formTask, index
													) in uniqueManageTaskProjectNames.filter(
														(el) =>
															!searched_Task_name ||
															el
																.toLowerCase()
																.includes(searched_Task_name.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formTask"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="
													selected_Manage_Task = [
														...uniqueManageTaskProjectNames,
													]
												"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Manage_Task = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Manage_Task.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div
										@click="get_Manage_Task_details(scope.$index, scope.row)"
										style="
											color: #ff8732;
											cursor: pointer;
											word-break: break-word;
											line-height: 120%;
										"
									>
										<u>{{ scope.row.project_info.name }}</u>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Frequency">
								<template slot="header" slot-scope="scope">
									Frequency
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Frequency_Manage_Task"
											size="mini"
											placeholder="Search Frequency"
										></el-input>
										<div
											style="
												max-height: 250px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group
												v-model="selected_Frequency_Manage_Task"
											>
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueFrequencyManageTaskNames.filter(
														(el) =>
															!searched_Frequency_Manage_Task ||
															el
																.toLowerCase()
																.includes(
																	searched_Frequency_Manage_Task.toLowerCase()
																)
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="
													selected_Frequency_Manage_Task = [
														...uniqueFrequencyManageTaskNames,
													]
												"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Frequency_Manage_Task = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Frequency_Manage_Task.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div style="text-transform: capitalize">
										{{ scope.row.frequency }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Start Date">
								<template slot-scope="scope">
									{{
										moment(scope.row.validity_start_date).format("Do MMM YYYY")
									}}
								</template>
							</el-table-column>
							<el-table-column label="Due Date">
								<template slot-scope="scope">
									{{
										moment(scope.row.validity_end_date).format("Do MMM YYYY")
									}}
								</template>
							</el-table-column>
							<el-table-column label="User">
								<template slot-scope="scope">
									<div style="font-size: 10px; margin-top: -5px">
										<span style="word-break: break-word; line-height: 120%">{{
											scope.row.full_name
										}}</span>
										<div
											style="
												word-break: break-word;
												line-height: 120%;
												color: #d26300;
												text-align: center;
											"
										>
											{{ scope.row.designation_name }}
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Status">
								<template slot-scope="scope">
									<el-tag
										size="small"
										style="border-radius: 12px; width: 70px; text-align: center"
										:style="
											scope.row.status != 'Draft'
												? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
												: 'border-color:#D26300; background-color:#FFF9F4; color:#D26300'
										"
										>{{ scope.row.status != "Draft" ? "Active" : "Draft" }}
									</el-tag>
								</template>
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip>
									<template slot-scope="scope">
										<img
											width="15px"
											class="mr-5"
											src="../../../../assets/images/download.png"
										/>
									</template>
								</el-table-column> -->
							<el-table-column show-overflow-tooltip>
								<template slot-scope="scope">
									<img
										@click="get_Manage_Task_details(scope.$index, scope.row)"
										width="15px"
										class="mr-5"
										src="../../../../assets/icons/EditIcon.png"
									/>
									<img
										@click="delete_Manage_Task_details(scope.$index, scope.row)"
										width="13px"
										src="../../../../assets/icons/Union.png"
									/>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row :gutter="10" class="mt-3">
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumberManageTask }} to
							{{ endNumberManageTask }} of {{ tableDataTask.length }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPageManageTask"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="tableDataTask.length"
							:page-size="perPageManageTask"
							:current-page.sync="currentPageManageTask"
						></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>
		<div v-if="showCreateTaskPage">
			<el-row>
				<el-col :span="1">
					<img
						@click="showCreateTaskPage = false"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div @click="showCreateTaskPage = false">Back</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-card shadow="none" style="border-radius: 12px">
						<div
							style="
								min-height: 53vh;
								max-height: 53vh;
								overflow-y: auto;
								overflow-x: hidden;
							"
						>
							<el-row>
								<el-col :span="2" :offset="6">
									<h2>{{ task_edit ? "Edit" : "New" }} Task</h2>
								</el-col>
							</el-row>
							<el-row style="margin-top: 30px">
								<el-col :span="3" :offset="6" style="margin-top: 10px">
									Category
								</el-col>
								<el-col :span="8">
									<el-select
										@change="list_forms"
										class="select"
										v-model="task_category"
										filterable
										placeholder="Select Category"
										v-validate="'required'"
										name="Select Category"
									>
										<el-option
											v-for="(item, idx) in category_items"
											:key="idx"
											:label="item.name"
											:value="item.id"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select Category`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Category`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</el-col>
							</el-row>
							<el-row style="margin-top: 30px">
								<el-col :span="3" :offset="6" style="margin-top: 10px">
									Form
								</el-col>
								<el-col :span="8">
									<el-select
										@change="all_form_items"
										class="select"
										v-model="task_form"
										filterable
										placeholder="Select Form"
										v-validate="'required'"
										name="Select Form"
										collapse-tags
										:clearable="true"
										:multiple="true"
									>
										<el-option
											v-for="(item, idx) in formItems"
											:key="idx"
											:label="item.name"
											:value="item.id"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select Form`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Form`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</el-col>
							</el-row>
							<el-row style="margin-top: 30px">
								<el-col :span="3" :offset="6" style="margin-top: 10px">
									Locations
								</el-col>
								<el-col :span="8">
									<el-select
										class="select"
										v-model="task_locations"
										filterable
										placeholder="Select Locations"
										v-validate="'required'"
										name="Select Locations"
										multiple
									>
										<el-option
											v-for="(item, idx) in locationItems"
											:key="idx"
											:label="item.name"
											:value="item.id"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select Locations`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Locations`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</el-col>
							</el-row>
							<el-row style="margin-top: 30px">
								<el-col :span="3" :offset="6" style="margin-top: 10px">
									Role / Designation
								</el-col>
								<el-col :span="8">
									<el-select
										class="select"
										v-model="task_designation"
										filterable
										placeholder="Select Designations"
										v-validate="'required'"
										name="Select Designations"
										:multiple="true"
									>
										<el-option
											v-for="(item, idx) in designationItems"
											:key="idx"
											:label="item.name"
											:value="item.id"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select Designations`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Designations`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</el-col>
							</el-row>
							<el-row style="margin-top: 30px">
								<el-col :span="3" :offset="6" style="margin-top: 10px">
									Dates
								</el-col>
								<el-col :span="4">
									<el-date-picker
										v-model="start_date"
										type="date"
										placeholder="Select Start Date"
										class="date"
										format="yyyy-MM-dd"
										v-validate="'required'"
										name="Select Start Date"
										:picker-options="datePickerOptions"
									>
									</el-date-picker>
									<p>
										<span
											:v-show="errors.has(`Select Start Date`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Start Date`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</el-col>
								<el-col style="margin-left: 10px" :span="4">
									<el-date-picker
										v-model="due_date"
										type="date"
										placeholder="Select Due Date"
										class="date"
										format="yyyy-MM-dd"
										v-validate="'required'"
										name="Select Due Date"
										:picker-options="fromDatePickerOptions"
									>
									</el-date-picker>
									<p>
										<span
											:v-show="errors.has(`Select Due Date`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Due Date`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</el-col>
							</el-row>
						</div>
						<el-row style="margin-top: 120px; margin-bottom: 60px">
							<el-col :span="3" :offset="20">
								<el-button
									@click="create_new_task()"
									class="button-class"
									style="width: 150px"
								>
									{{ task_edit ? "Save" : "Create" }}
								</el-button>
							</el-col>
						</el-row>
					</el-card>
				</el-col>
			</el-row>
		</div>
		<div v-if="active_view == 'FORM'">
			<FormListsVue @click="hide_tab" @show_form="hide_add_form" />
		</div>
		<div v-if="active_view == 'DASHBOARD'">
			<V2DashboardVue
				@hide_upper_tabs="hide_top_tab = true"
				@hide_upper_tabs_false="hide_top_tab = false"
				:hidden="true"
			/>
			<V2NewDashboardVue :company_details="company_details" @get_ViewType="getViewType" />
		</div>
		<div
			v-if="active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'"
		>
			<CreateProjectVue
				:active_view="active_view"
				@close="get_active_project_view()"
				:storeObj="storeObj"
			/>
		</div>
		<div v-if="active_view == 'CREATE_TASK' || active_view == 'EDIT_TASK'">
			<el-row style="margin-top: -10px; margin-bottom: 10px">
				<el-col :span="1">
					<img
						@click="get_active_project_view()"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer; position: relative; z-index: 1"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div
						@click="get_active_project_view()"
						style="cursor: pointer; position: relative; z-index: 1"
					>
						Back
					</div>
				</el-col>
			</el-row>
			<CreateTaskVue
				:active_view="active_view"
				@close="get_active_project_view()"
				:storeObj="storeObj"
			/>
		</div>
		<div v-if="active_view == 'Action'">
			<ActionVue
				:show_list_action_page="show_list_action_page"
				@show_view_page="appropriate_actions_view_page"
				:storeObj="storeObj"
				@hide_view_page="show_list_action_page = '1'"
				@show_submit_page="appropriate_actions_submit_page"
				:storeObjSubmit="storeObjSubmit"
				@recall_page_2="appropriate_actions_recall_page_2"
				@rejectReasonPage="appropriate_rejectReasonPage"
				@show_page_2="appropriate_show_page_2"
				@refresh_to_page_2="appropriate_actions_refresh_to_page_2"
				:getUserDetails="company_details"
			/>
		</div>
		<div v-if="active_view == 'VIEW_QUESTIONS'">
			<el-row style="margin-top: -10px; margin-bottom: -10px">
				<el-col :span="1">
					<img
						@click="check_changes()"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer; position: relative; z-index: 1"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div
						@click="check_changes()"
						style="cursor: pointer; position: relative; z-index: 1"
					>
						Back
					</div>
				</el-col>
			</el-row>
			<el-dialog
				:visible.sync="confirmationDialog"
				width="30%"
				title="Confirmation Dialog"
				class="header hide-overflow"
				:before-close="dialog_cancel"
			>
				<span>Do you want to exit without saving?</span>
				<div>
					<el-row :gutter="10">
						<el-col :span="5" :offset="13">
							<el-button
								class="button-class-white2"
								style="border: none; margin-top: 40px"
								@click="dialog_cancel"
								>Cancel</el-button
							>
						</el-col>
						<el-col :span="5">
							<el-button class="button-class" @click="dialog_success"
								>Confirm</el-button
							>
						</el-col>
						<el-col :span="1"> </el-col>
					</el-row>
				</div>
			</el-dialog>
			<ViewQuestionsVue
				:preview_formItemArray="preview_formItemArray"
				:formDetails="formDetails"
				@raise="trigger_raise_ticket_values"
				:description="description"
				:current_obj="current_obj"
				:current_question_idx="current_question_idx"
				@next_question="get_next_question"
				@prev_question="get_prev_question"
				@save_filled_question="save_n_exit"
				:showing_index="showing_index"
				:tableDataActiveSectionAbout="tableDataActiveSectionAbout"
				:Question_form_Details="Question_form_Details"
				:current_category_item="current_category_item"
				:current_category_index="current_category_index"
				@next_category="go_to_next_category"
				@prev_category="go_to_prev_category"
				:tableDataActiveCategory="tableDataActiveCategory"
				:company_details="company_details"
				:project_info_object="project_info_object"
				@get_updated_array="getQuestionsOfForm"
				@update_preview_formItemArray1="update_preview_formItemArray1_method"
				:calling_api="calling_api"
				@calling_api_true="calling_api = true"
				@calling_api_false="calling_api = false"
			/>
		</div>
		<div v-if="active_view == 'VIEW_QUESTIONS_SECTION'">
			<el-row style="margin-top: -10px; margin-bottom: -10px">
				<el-col :span="1">
					<img
						@click="check_changes()"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer; position: relative; z-index: 1"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div
						@click="check_changes()"
						style="cursor: pointer; position: relative; z-index: 1"
					>
						Back
					</div>
				</el-col>
			</el-row>
			<el-dialog
				:visible.sync="confirmationDialog"
				width="30%"
				title="Confirmation Dialog"
				class="header hide-overflow"
				:before-close="dialog_cancel"
			>
				<span>Do you want to exit without saving?</span>
				<div>
					<el-row :gutter="10">
						<el-col :span="5" :offset="13">
							<el-button
								class="button-class-white2"
								style="border: none; margin-top: 40px"
								@click="dialog_cancel"
								>Cancel</el-button
							>
						</el-col>
						<el-col :span="5">
							<el-button class="button-class" @click="dialog_success"
								>Confirm</el-button
							>
						</el-col>
						<el-col :span="1"> </el-col>
					</el-row>
				</div>
			</el-dialog>
			<ViewQuestionForSectionVue
				:preview_formItemArray="preview_formItemArray"
				:formDetails="formDetails"
				@raise="trigger_raise_ticket_values"
				@save_filled_question="save_n_exit"
				:description="description"
				:current_obj="current_obj"
				:current_question_idx="current_question_idx"
				@next_question="get_next_question"
				@prev_question="get_prev_question"
				:showing_index="showing_index"
				:tableDataActiveSectionAbout="tableDataActiveSectionAbout"
				:Question_form_Details="Question_form_Details"
				:current_category_item="current_category_item"
				:current_category_index="current_category_index"
				@next_category="go_to_next_category"
				@prev_category="go_to_prev_category"
				:tableDataActiveCategory="tableDataActiveCategory"
				:company_details="company_details"
				:project_info_object="project_info_object"
				@get_updated_array="getQuestionsOfForm"
				@update_preview_formItemArray1="update_preview_formItemArray1_method"
			/>
		</div>

		<div v-if="active_view == 'RAISE_TICKET'">
			<el-row style="margin-top: -10px; margin-bottom: 0px">
				<el-col :span="1">
					<img
						@click="trigger_raise_ticket_back()"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div @click="trigger_raise_ticket_back()">Back</div>
				</el-col>
			</el-row>
			<RaiseTicketVue
				:formDetails="formDetails"
				:locations="locations"
				:locationItems="locationItems"
				:category_name="category_name"
				@close="get_close_ticket_value"
				:current_obj="current_obj"
			/>
		</div>
		<DeleteConfirmationVue
			:deleteDialog="deleteDialog"
			:confirmationObject="confirmationObject"
			@cancel="deleteDialog = false"
			@success="delete_project_api"
			:confirmationTitle="confirmationTitle"
		/>
		<SubmitFormDialog
			@clicked="get_appropriate_actions_submit"
			@close="submitFlowDialog = false"
			:submitFlowDialog="submitFlowDialog"
			:project_info_object="project_info_object"
			@reopen="reopen_dialog"
		/>
		<ProjectReview
			@close="projectReviewDialog = false"
			:projectReviewDialog="projectReviewDialog"
			:project_info_object="project_info_object"
			@clicked="get_appropriate_actions_submit"
		/>
		<div v-if="active_view == 'VIEW_QUESTIONS_DETAILS'">
			<el-row style="margin-top: -10px; margin-bottom: -10px">
				<el-col :span="1">
					<img
						@click="check_changes()"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer; position: relative; z-index: 1"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div
						@click="check_changes()"
						style="cursor: pointer; position: relative; z-index: 1"
					>
						Back
					</div>
				</el-col>
			</el-row>
			<el-dialog
				:visible.sync="confirmationDialog"
				width="30%"
				title="Confirmation Dialog"
				class="header hide-overflow"
				:before-close="dialog_cancel"
			>
				<span>Do you want to exit without saving?</span>
				<div>
					<el-row :gutter="10">
						<el-col :span="5" :offset="13">
							<el-button
								class="button-class-white2"
								style="border: none; margin-top: 40px"
								@click="dialog_cancel"
								>Cancel</el-button
							>
						</el-col>
						<el-col :span="5">
							<el-button class="button-class" @click="dialog_success"
								>Confirm</el-button
							>
						</el-col>
						<el-col :span="1"> </el-col>
					</el-row>
				</div>
			</el-dialog>
			<FormQuestionDetails
				:calling_api="calling_api"
				@calling_api_true="calling_api = true"
				@calling_api_false="calling_api = false"
				:current_category_item="current_category_item"
				:project_info_object="project_info_object"
				:Question_form_Details="Question_form_Details"
				:formDetails="formDetails"
				:formItemObject="formItemObject"
				@next_category="go_to_next_category"
				@prev_category="go_to_prev_category"
				@next_question="get_next_question"
				@prev_question="get_prev_question"
				@save_filled_question="save_n_exit"
				:current_category_index="current_category_index"
				:tableDataActiveCategory="tableDataActiveCategory"
				@raise="trigger_raise_ticket_values"
				:tableDataActiveSectionAbout="tableDataActiveSectionAbout"
				:current_question_idx="current_question_idx"
				:show_buttons="show_buttons"
				:company_details="company_details"
			/>
		</div>
	</div>
</template>

<script>
import formBuilderServices from "../../../../services/formBuilderServices";
import TasksVue from "../../labourPlaninig/tasks/Tasks.vue";
import CreateProjectVue from "../CreateProject.vue";
import CreateTaskVue from "./CreateTask.vue";
import FormListsVue from "../FormLists.vue";
import V2DashboardVue from "../V2Dashboard/V2Dashboard.vue";
import V2NewDashboardVue from "../V2NewDashboard/Dashboard.vue";
import ActionVue from "./Actions.vue";
import DeleteConfirmationVue from "./DeleteConfirmation.vue";
import RaiseTicketVue from "./RaiseTicket.vue";
import ViewQuestionForSectionVue from "./ViewQuestionForSection.vue";
import ViewQuestionsVue from "./ViewQuestions.vue";
import { serverAddr } from "../../../../networkConfig";
import SubmitFormDialog from "./SubmitFormDialog.vue";
import ProjectReview from "./ProjectReview.vue";
import FormQuestionDetails from "./FormQuestionDetails.vue";
var moment = require("moment");
export default {
	components: {
		FormListsVue,
		TasksVue,
		CreateProjectVue,
		ViewQuestionsVue,
		RaiseTicketVue,
		ViewQuestionForSectionVue,
		DeleteConfirmationVue,
		ActionVue,
		V2DashboardVue,
		CreateTaskVue,
		SubmitFormDialog,
		V2NewDashboardVue,
		ProjectReview,
		FormQuestionDetails,
	},
	data: () => ({
		view_type: "1",
		calling_api: false,
		submitFlowDialog: false,
		datePickerOptions: {
			firstDayOfWeek: 1,
			// disabledDate(date) {
			// 	return date > moment().subtract(0, "days");
			// },
		},
		search_form: "",
		tableData1: [],
		task_category: "",
		task_form: [],
		task_locations: [],
		task_designation: [],
		height1: 0,
		isloading: false,
		confirmationTitle: "",
		confirmationObject: {},
		deleteDialog: false,
		childPagesItems: [
			{ name: "Dashboard", value: "Dashboard", active: true },
			{ name: "Projects & Tasks", value: "Projects", active: false },
			// { name: "Tasks", value: "Tasks", active: false },
			{ name: "Action", value: "Action", active: false },
			{ name: "Forms", value: "Forms", active: false },
		],
		projectPagesItems: [],
		search: "",
		tableData: [],
		tableDataActive: [],
		tableDataActiveTask: [],
		tableDataActiveCategory: [],
		tableDataActiveSectionAbout: [],
		start_date: "",
		locations: "",
		locationItems: [],
		show_active_project: false,
		show_category_card: false,
		active_view: "DASHBOARD",
		taskPagesItems: [
			{ name: "Active", value: "Active", active: true },
			{ name: "Manage Tasks", value: "Manage Tasks", active: false },
			{ name: "Archived", value: "Archived", active: false },
		],
		showCreateTaskPage: false,
		show_list_action_page: "1",
		category: "",
		category_items: [],
		form: "",
		formItems: [],
		start_date: "",
		due_date: "",
		designationItems: [],
		designation: "",
		locations: "",
		locationItems: [],
		active_date: "",
		show_add_form: false,
		tableDataTask: [],
		preview_formItemArray: [],
		formDetails: {},
		current_obj: {},
		category_name: {},
		moment: null,
		show_type: null,
		storeObj: {},
		project_info_name: "",
		project_info_status: "",
		current_arr: [],
		description: null,
		project_info_object: {},
		current_question_idx: null,
		showing_index: false,
		perPage: 10,
		currentPage: 1,
		searched_form_name: "",
		selected_Active_project: [],
		searched_Frequency_name: "",
		selected_Frequency_project: [],
		search_projects: "",
		perPageManage: 10,
		currentPageManage: 1,
		selected_Manage_project: [],
		searched_Manage_name: "",
		searched_Frequency_Manage: [],
		searched_Frequency_Manage: "",
		selected_Frequency_Manage: [],
		search_active_task: "",
		selected_Frequency_Active_Task: [],
		selected_Active_Task: [],
		searched_Frequency_Active_Task: "",
		currentPageActiveTask: 1,
		perPageActiveTask: 10,
		currentPageManageTask: 1,
		perPageManageTask: 10,
		selected_Frequency_Manage_Task: [],
		searched_Frequency_Manage_Task: "",
		selected_Manage_Task: [],
		searched_form_name: "",
		search_Manage_task: "",
		searched_Task_name: "",
		current_category_index: 0,
		current_category_item: {},
		Question_form_Details: {},
		task_edit: false,
		editTaskObject: {},
		company_details: {},
		confirmationDialog: false,
		visible: false,
		quick_task: false,
		storeObjSubmit: {},
		preview_formItemArray1: [],
		is_bt: false,
		hide_top_tab: false,
		projectReviewDialog: false,
		formItemObject: {},
		show_buttons:false,
	}),
	mounted() {
		this.is_bt = JSON.parse(localStorage.getItem("check_company")).is_bt;
		console.log(this.is_bt, "aksjdh");
		// this.isloading = true;
		// this.list_all_locations("project");
		// this.list_all_locations("standalone");
		this.moment = moment;
		this.get_company_id();
	},
	computed: {
		getFormsTotal() {
			let total_overall_forms = 0;
			let total_completed_form = 0;
			for (let i = 0; i < this.tableDataActiveCategory.length; i++) {
				if (
					this.tableDataActiveCategory[i].task_status_update_info.completed ==
					null
				) {
					this.tableDataActiveCategory[i].task_status_update_info.completed = 0;
				}
				if (
					this.tableDataActiveCategory[i].task_status_update_info.total == null
				) {
					this.tableDataActiveCategory[i].task_status_update_info.total = 0;
				}
				total_overall_forms +=
					this.tableDataActiveCategory[i].task_status_update_info.total;
				total_completed_form +=
					this.tableDataActiveCategory[i].task_status_update_info.completed;
			}
			return `${total_completed_form} / ${total_overall_forms} completed`;
		},
		getScoreTotal() {
			let total_overall_forms = 0;
			let total_completed_form = 0;
			for (let i = 0; i < this.tableDataActiveCategory.length; i++) {
				if (
					this.tableDataActiveCategory[i].task_status_update_info
						.current_score == null
				) {
					this.tableDataActiveCategory[
						i
					].task_status_update_info.current_score = 0;
				}
				if (
					this.tableDataActiveCategory[i].task_status_update_info.total_score ==
					null
				) {
					this.tableDataActiveCategory[
						i
					].task_status_update_info.total_score = 0;
				}
				total_overall_forms +=
					this.tableDataActiveCategory[i].task_status_update_info.total_score;
				total_completed_form +=
					this.tableDataActiveCategory[i].task_status_update_info.current_score;
			}
			return `${total_completed_form} / ${total_overall_forms} points`;
		},
		getCompletionTotal() {
			let total_overall_forms = 0;
			let total_completed_form = 0;
			for (let i = 0; i < this.tableDataActiveCategory.length; i++) {
				if (
					this.tableDataActiveCategory[i].task_status_update_info.completed ==
					null
				) {
					this.tableDataActiveCategory[i].task_status_update_info.completed = 0;
				}
				if (
					this.tableDataActiveCategory[i].task_status_update_info.total == null
				) {
					this.tableDataActiveCategory[i].task_status_update_info.total = 0;
				}
				total_overall_forms +=
					this.tableDataActiveCategory[i].task_status_update_info.total;
				total_completed_form +=
					this.tableDataActiveCategory[i].task_status_update_info.completed;
			}
			let cal_val = 0;
			if (total_overall_forms == 0 || total_completed_form == 0) {
				cal_val = 0;
			} else {
				cal_val = (total_completed_form / total_overall_forms) * 100;
			}
			return `${cal_val.toFixed(2)} %`;
		},
		getCompletionScoreTotal() {
			let total_overall_forms = 0;
			let total_completed_form = 0;
			for (let i = 0; i < this.tableDataActiveCategory.length; i++) {
				if (
					this.tableDataActiveCategory[i].task_status_update_info
						.current_score == null
				) {
					this.tableDataActiveCategory[
						i
					].task_status_update_info.current_score = 0;
				}
				if (
					this.tableDataActiveCategory[i].task_status_update_info.total_score ==
					null
				) {
					this.tableDataActiveCategory[
						i
					].task_status_update_info.total_score = 0;
				}
				total_overall_forms +=
					this.tableDataActiveCategory[i].task_status_update_info.total_score;
				total_completed_form +=
					this.tableDataActiveCategory[i].task_status_update_info.current_score;
			}
			let cal_val = 0;
			if (total_overall_forms == 0 || total_completed_form == 0) {
				cal_val = 0;
			} else {
				cal_val = (total_completed_form / total_overall_forms) * 100;
			}
			return `${cal_val.toFixed(2)} %`;
		},
		fromDatePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: this.disableFromDatePickerDates,
			};
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		startNumberManage() {
			let start =
				this.currentPageManage * this.perPageManage - (this.perPageManage - 1);
			return start;
		},
		startNumberManageTask() {
			let start =
				this.currentPageManageTask * this.perPageManageTask -
				(this.perPageManageTask - 1);
			return start;
		},
		endNumberManageTask() {
			let end = Math.min(
				this.startNumberManageTask + this.perPageManageTask - 1,
				this.tableDataTask.length
			);
			return end;
		},
		startNumberActiveTask() {
			let start =
				this.currentPageActiveTask * this.perPageActiveTask -
				(this.perPageActiveTask - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.tableDataActive.length
			);
			return end;
		},
		endNumberActiveTask() {
			let end = Math.min(
				this.startNumberActiveTask + this.perPageActiveTask - 1,
				this.tableDataActiveTask.length
			);
			return end;
		},
		endNumberManage() {
			let end = Math.min(
				this.startNumberManage + this.perPageManage - 1,
				this.tableData.length
			);
			return end;
		},
		uniqueFormNames() {
			let arr = [...new Set(this.tableDataActive.map((el) => el.project_name))];
			return arr;
		},
		uniqueFrequencyNames() {
			let arr = [...new Set(this.tableDataActive.map((el) => el.frequency))];
			return arr;
		},
		uniqueFrequencyManageTaskNames() {
			let arr = [...new Set(this.tableDataTask.map((el) => el.frequency))];
			return arr;
		},
		uniqueFrequencyNamesManage() {
			let arr = [...new Set(this.tableData.map((el) => el.frequency))];
			return arr;
		},
		uniqueManageProjectNames() {
			let arr = [...new Set(this.tableData.map((el) => el.project_info.name))];
			return arr;
		},
		uniqueActiveTaskProjectNames() {
			let arr = [
				...new Set(this.tableDataActiveTask.map((el) => el.project_name)),
			];
			return arr;
		},
		uniqueManageTaskProjectNames() {
			let arr = [
				...new Set(this.tableDataTask.map((el) => el.project_info.name)),
			];
			this.$forceUpdate();
			return arr;
		},
		uniqueFrequencyActiveTaskNames() {
			let arr = [
				...new Set(this.tableDataActiveTask.map((el) => el.frequency)),
			];
			return arr;
		},
	},
	watch: {
		projectPagesItems: {
			handler: function (val, oldVal) {
				if (this.company_details.access_level == "admin") {
					if (val[1].active == true) {
						this.isloading = true;
						this.list_manage_projects("project");
					}
				}
				if (val[0].active == true) {
					this.isloading = true;
					this.list_all_locations("project");
				}
			},
			deep: true,
		},
		taskPagesItems: {
			handler: function (val, oldVal) {
				if (val[1].active == true) {
					this.isloading = true;
					this.list_manage_projects("standalone");
				}
				if (val[0].active == true) {
					this.isloading = true;
					this.list_all_locations("standalone", 1);
				}
			},
			deep: true,
		},
		childPagesItems: {
			handler: function (val, oldVal) {
				if (val[2].active == true) {
					this.isloading = true;
					this.list_all_locations("standalone");
				}
				if (val[1].active == true) {
					this.isloading = true;
					this.list_all_locations("project", null);
				}
			},
			deep: true,
		},
		showCreateTaskPage(val) {
			if (val) {
				this.list_all_categories();
				this.list_all_locations("standalone");
				this.list_designations();
			}
		},
		locations(val) {
			if (this.company_details.access_level == "admin") {
				let date = moment(new Date(this.active_date)).format("YYYY-MM-DD");
				let params = {
					location: val,
					date: date,
				};
				this.list_active_projects(params);
			}
		},
		active_date(val) {
			let date = moment(new Date(val)).format("YYYY-MM-DD");
			let params = {
				location: this.locations,
				date: date,
			};
			this.list_active_projects(params);
		},
	},
	methods: {
		projectReview() {
			this.projectReviewDialog = true;
		},
		getViewType(val) {
			this.view_type = val;
		},
		reopen_dialog() {
			this.submitFlowDialog = false;

			// setTimeout(() => {
			// 	this.submitFlowDialog = true;
			// }, 50);
		},
		get_appropriate_actions_submit(anyTimeApiId) {
			this.projectReviewDialog = false;
			this.submitFlowDialog = false;
			this.show_active_project = false;
			this.active_view = "PROJECT";
			let date = moment(new Date(this.active_date)).format("YYYY-MM-DD");
			let params = {
				location: this.locations,
				date: date,
				execution_type: "project",
			};
			this.tableDataActive = [];
			this.tableDataActiveTask = [];
			formBuilderServices.listActiveProjects(params).then((res) => {
				let response = JSON.parse(res.data).data;
				response.sort(
					(a, b) =>
						b.execution_setup_info.project_info.serial_no -
						a.execution_setup_info.project_info.serial_no
				);
				response.forEach((el) => {
					el.project_name = el.execution_setup_info.project_info.name;
					el.frequency = el.execution_setup_info.frequency;
				});
				this.tableDataActive = response;
				console.log(this.tableDataActive, "this.tableDataActive");
				console.log(this.locations, "this.locations");
				// this.tableDataActiveTask = response;
				let obj = {};
				for (let i = 0; i < this.tableDataActive.length; i++) {
					if (this.tableDataActive[i].id == this.project_info_object.id) {
						obj = this.tableDataActive[i];
					}
				}
				this.get_active_project_details(obj, "0", "5", anyTimeApiId);
				setTimeout(() => {
					this.calling_api = false;
				}, 1000);
			});
		},
		submit_form_condition_check() {
			console.log(this.project_info_object, "project_info_object");
			if (
				this.project_info_object.execution_setup_info.project_sign_off_required
			) {
				this.submitFlowDialog = true;
			} else {
				this.call_submit_form_api();
			}
			// this.submitFlowDialog = true;
		},
		call_submit_form_api() {
			let params = {
				project_id: this.project_info_object.id,
				submitted: true,
				auditor_sign_file_path: null,
				auditee_sign_file_path: null,
				auditor: null,
				submitted_on_device: "web",
			};
			formBuilderServices.markSubmitted(params).then((res) => {
				console.log(res, "responsaef");
				// this.get_active_project_details(this.project_info_object, "0");
				// setTimeout(() => {
				this.$notify.success({
					title: "Success",
					message: "Project Submitted Successfully",
				});
				// 	this.loading = false;
				// 	this.submitDialog = false;
				// 	this.show_active_project = false;
				// }, 500);
				this.get_appropriate_actions_submit();
			});
		},
		cal_launch_api() {
			let params = {
				execution_setup: this.project_info_object.execution_setup_info.id,
				location: this.locations,
			};
			// Show confirmation dialog
			this.$confirm(
				"A new form will be created. Do you wish to continue?",
				"Alert",
				{
					confirmButtonText: "OK",
					cancelButtonText: "Cancel",
					type: "warning",
				}
			)
				.then(() => {
					formBuilderServices.launchProjectApi(params).then((res) => {
						this.get_appropriate_actions_submit(JSON.parse(res.data));
					});
				})
				.catch(() => {});
		},
		update_preview_formItemArray1_method(arr) {
			this.preview_formItemArray1 = JSON.parse(JSON.stringify(arr));
		},
		check_changes() {
			console.log(this.preview_formItemArray, this.preview_formItemArray1);
			if (
				JSON.stringify(this.preview_formItemArray) ==
				JSON.stringify(this.preview_formItemArray1)
			) {
				console.log("Arrays are equal");
				this.dialog_success();
			} else {
				console.log("Arrays are not equal");
				this.confirmationDialog = true;
			}
		},
		appropriate_rejectReasonPage(item) {
			this.storeObj = {};
			this.storeObj = item;
			this.show_list_action_page = "5";
		},
		appropriate_actions_refresh_to_page_2(item) {
			this.storeObj = {};
			this.storeObj = item;
			this.show_list_action_page = "2";
		},
		appropriate_show_page_2(item) {
			this.storeObjSubmit = {};
			this.storeObjSubmit = item;
			this.show_list_action_page = "3";
		},
		appropriate_actions_recall_page_2() {
			this.show_list_action_page = "4";
		},
		appropriate_actions_view_page(item) {
			this.storeObj = {};
			this.storeObj = item;
			this.show_list_action_page = "2";
		},
		appropriate_actions_submit_page(item) {
			this.storeObjSubmit = {};
			this.storeObjSubmit = item;
			this.show_list_action_page = "3";
		},
		dialog_cancel() {
			this.confirmationDialog = false;
		},
		dialog_success() {
			if (this.quick_task) {
				this.show_active_project = false;
				this.active_view = "PROJECT";
			} else {
				this.trigger_view_questions_back();
			}
			this.confirmationDialog = false;
		},
		get_company_id() {
			serverAddr
				.get("/users/self/", {})
				.then((res) => {
					// this.$store.commit("getUserDetails", JSON.parse(res.data));
					// user_info = this.$store.state.loginUserDetails;
					// this.email = user_info.email;
					this.company_details = JSON.parse(res.data);
					console.log(this.company_details,'cd')
					if (this.company_details.access_level == "admin") {
						this.projectPagesItems = [
							{ name: "Active", value: "Active", active: true },
							{
								name: "Manage",
								value: "Manage Projects",
								active: false,
							},
							{ name: "Archived", value: "Archived", active: false },
						];
						// Updated for email link redirection
						if (
							Object.keys(this.$route.query).length &&
							this.$route.query.tab
						) {
							this.active_view = "Action";
							this.childPagesItems = [
								{ name: "Dashboard", value: "Dashboard", active: false },
								{ name: "Projects & Tasks", value: "Projects", active: false },
								{ name: "Action", value: "Action", active: true },
								{ name: "Forms", value: "Forms", active: false },
							];
						} else {
							this.childPagesItems = [
								{ name: "Dashboard", value: "Dashboard", active: true },
								{ name: "Projects & Tasks", value: "Projects", active: false },
								{ name: "Action", value: "Action", active: false },
								{ name: "Forms", value: "Forms", active: false },
							];
						}
					} else {
						this.projectPagesItems = [
							{ name: "Active", value: "Active", active: true },
							{ name: "Archived", value: "Archived", active: false },
						];
						// Updated for email link redirection
						if (
							Object.keys(this.$route.query).length &&
							this.$route.query.tab
						) {
							this.active_view = "Action";
							this.childPagesItems = [
								{ name: "Dashboard", value: "Dashboard", active: true },
								{ name: "Projects & Tasks", value: "Projects", active: false },
								{ name: "Action", value: "Action", active: false },
							];
						} else {
							this.childPagesItems = [
								{ name: "Dashboard", value: "Dashboard", active: true },
								{ name: "Projects & Tasks", value: "Projects", active: false },
								{ name: "Action", value: "Action", active: false },
							];
						}
					}
				})
				.catch((error) => {
					console.error("error", error);
				});
		},
		go_to_next_category(idx) {
			this.isloading = true;
			for (let i = 0; i < this.tableDataActiveCategory.length; i++) {
				this.tableDataActiveCategory[i].active = false;
			}
			this.tableDataActiveCategory[idx + 1].active = true;
			this.current_category_index = idx + 1;
			this.current_category_item =
				this.tableDataActiveCategory[this.current_category_index];
			this.get_active_catagory_details(
				new Array(this.current_category_item),
				"3",
				"0"
			);
			setTimeout(() => {
				this.calling_api = false;
			}, 1000);
		},
		go_to_prev_category(idx) {
			this.isloading = true;
			for (let i = 0; i < this.tableDataActiveCategory.length; i++) {
				this.tableDataActiveCategory[i].active = false;
			}
			this.tableDataActiveCategory[idx - 1].active = true;
			this.current_category_index = idx - 1;
			this.current_category_item =
				this.tableDataActiveCategory[this.current_category_index];
			this.get_active_catagory_details(
				new Array(this.current_category_item),
				"3",
				"0"
			);
			setTimeout(() => {
				this.calling_api = false;
			}, 1000);
		},
		get_Manage_Task_details(idx, item) {
			this.task_edit = true;
			this.task_category = null;
			this.task_form = null;
			this.editTaskObject = item;
			this.start_date = item.validity_start_date;
			this.task_designation = item.designations;
			this.task_locations = item.locations;
			this.task_category =
				item.execution_category_mappings_list[0].form_category;
			this.list_forms("1");
			this.due_date = item.validity_end_date;
			this.task_form = item.execution_category_mappings_list[0].forms;
			this.showCreateTaskPage = true;
		},
		delete_Manage_Task_details(idx, item) {
			this.confirmationObject = item;
			this.confirmationObject.type = "standalone";
			this.confirmationTitle = `Are you sure to delete the task ${item.project_info.name} ?`;
			this.deleteDialog = true;
		},
		hide_add_form() {
			this.show_add_form = false;
		},
		disableFromDatePickerDates(date) {
			if (!this.start_date) {
				return false;
			}
			return date <= this.start_date;
		},
		list_designations() {
			formBuilderServices.listAllDesignations().then((res) => {
				this.designationItems = JSON.parse(res.data);
			});
		},
		all_form_items() {
			if (this.task_form == "All") {
				this.task_form = [];
				for (let i = 0; i < this.formItems.length; i++) {
					if (this.formItems[i].id != "All") {
						this.task_form.push(this.formItems[i].id);
					}
				}
			}
		},
		list_forms(val) {
			formBuilderServices
				.listFormsByCategoryId(this.task_category)
				.then((res) => {
					this.task_form = [];
					this.formItems = JSON.parse(res.data);
					this.formItems.unshift({ name: "All", id: "All" });
					if (val == "1") {
						this.task_form =
							this.editTaskObject.execution_category_mappings_list[0].forms;
					}
				});
		},
		list_all_categories() {
			formBuilderServices.listAllCategory().then((res) => {
				this.category_items = JSON.parse(res.data);
				this.category_items_new = JSON.parse(res.data);
			});
		},
		create_new_task() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.isloading = true;
					let proj_name = this.formItems.filter(
						(el) => el.id == this.task_form[0]
					)[0].name;
					let params = {
						project: {
							name: proj_name,
							id: this.task_edit ? this.editTaskObject.id : null,
						},
						execution_setup: {
							id: this.task_edit ? this.editTaskObject.id : null,
							execution_type: "standalone",
							assign_to: "designation",
							assign_by: "location",
							designations: this.task_designation,
							locations: this.task_locations,
							validity_start_date: moment(this.start_date).format("YYYY-MM-DD"),
							validity_end_date: moment(this.due_date).format("YYYY-MM-DD"),
							validity_never_ends: false,
							frequency: "monthly",
							daily_schedule_plan: "specific_time",
							weekly_schedule_plan: "specific_day_in_a_week",
							monthly_schedule_plan: "date_of_the_month",
							months_list: ["jan", "feb"],
							date_range_start: 1,
							date_range_end: 1,
							are_grades_applicable: false,
							notification_designations: [],
							report_designations: [],
							notification_on_project_start: true,
							notification_on_project_completed: true,
							notification_on_project_overdue: true,
							reminder_before_project_starts: "00:00:00",
							reminder_before_project_ends: "00:00:00",
						},
						execution_category_mappings: [
							{
								id: this.task_edit
									? this.editTaskObject.execution_category_mappings_list[0].id
									: null,
								form_category: this.task_category,
								forms: this.task_form,
								is_critical: false,
								allowed_on: "all",
							},
						],
						daily_schedule_times: [],
						week_schedule_days: [],
						month_schedule_dates: [],
						grades: [],
					};
					formBuilderServices
						.addProject(params)
						.then((res) => {
							this.$notify.success({
								title: "Success",
								message: "Task Created Successfully",
								type: "Success",
							});
							this.list_manage_projects("standalone");
							this.showCreateTaskPage = false;
							this.isloading = false;
						})
						.catch(() => {
							this.isloading = false;
						});
				} else {
					alert("Enter required fields");
				}
			});
		},
		get_next_question() {
			this.showing_index = false;
			this.isloading = true;
			let next_ind = this.current_question_idx + 1;
			let next_obj = this.tableDataActiveSectionAbout[next_ind];
			this.getQuestionsOfForm(next_obj, next_ind);
			setTimeout(() => {
				this.calling_api = false;
			}, 1000);
			this.$forceUpdate();
		},
		get_prev_question() {
			this.showing_index = false;
			this.isloading = true;
			let next_ind = this.current_question_idx - 1;
			let next_obj = this.tableDataActiveSectionAbout[next_ind];
			this.getQuestionsOfForm(next_obj, next_ind);
			setTimeout(() => {
				this.calling_api = false;
			}, 1000);
			this.$forceUpdate();
		},
		get_res_by_location(val, type) {
			let date = moment(new Date(this.active_date)).format("YYYY-MM-DD");
			let params = {
				location: this.locations,
				date: date,
				execution_type: type,
			};
			if (val == 0) {
				this.list_active_projects(params, type);
			} else {
				this.list_active_projects(params, type, val);
			}
		},
		show_action_update_screen(item) {
			this.storeObj = item;
			if (this.storeObj.resolved_attachments_info.length != 0) {
				this.storeObj.resolved_attachments_info.forEach(async (el) => {
					let params = {
						file_path: el.file_path,
						storage: "task",
					};
					await formBuilderServices.getAttachmentURL(params).then((res) => {
						el.img = JSON.parse(res.data).data;
					});
				});
			}
			if (this.storeObj.issue_attachments_info.length != 0) {
				this.storeObj.issue_attachments_info.forEach(async (el) => {
					let params = {
						file_path: el.file_path,
						storage: "task",
					};
					await formBuilderServices.getAttachmentURL(params).then((res) => {
						el.img = JSON.parse(res.data).data;
					});
				});
				setTimeout(() => {
					this.show_list_action_page = true;
				}, 200);
				this.$forceUpdate();
			} else {
				this.show_list_action_page = true;
			}
		},
		delete_project_api(item) {
			formBuilderServices
				.deleteManageProjects(item.project_info.id)
				.then(() => {
					this.$notify.success({
				title: "Success",
				message: "Project deleted successfully",
				type: "Success",
			});
					this.list_manage_projects(item.type);
					this.deleteDialog = false;
				});
		},
		delete_manage_projects_method(idx, item) {
			this.confirmationObject = item;
			this.confirmationObject.type = "project";
			this.confirmationTitle = `Are you sure to delete the project ${item.project_info.name} ?`;
			this.deleteDialog = true;
		},
		edit_project_method(idx, item) {
			this.storeObj = {};
			this.storeObj = item;
			this.storeObj.action = "EDIT";
			this.active_view = "EDIT_PROJECT";
		},
		get_active_project_view() {
			this.list_manage_projects("project");
			this.active_view = "PROJECT";
		},
		save_n_exit() {
			this.$notify.success({
				title: "Success",
				message: "Question Updated Successfully",
				type: "Success",
			});
			if (this.quick_task) {
				this.show_active_project = false;
				this.active_view = "PROJECT";
				this.list_all_locations("project", null);
				setTimeout(() => {
					this.calling_api = false;
				}, 1000);
			} else {
				this.get_appropriate_actions_submit();
				setTimeout(() => {
					this.active_view = "PROJECT";
					this.show_active_project = true;
				}, 1000);
			}
		},
		get_close_ticket_value(description, current_obj) {
			this.description = description;
			this.current_obj = current_obj;
			this.active_view = "VIEW_QUESTIONS_DETAILS";
		},
		trigger_raise_ticket_values(item, arr) {
			this.current_obj = item;
			this.current_arr = arr;
			this.active_view = "RAISE_TICKET";
			console.log(
				this.current_obj,
				this.current_arr,
				this.active_view,
				"this.active_view"
			);
		},
		trigger_raise_ticket_back() {
			this.active_view = "VIEW_QUESTIONS_DETAILS";
			// this.show_active_project = true;
		},
		trigger_view_questions_back() {
			this.show_active_project = true;
			this.active_view = "PROJECT";
		},
		change_active_category(idx, item) {
			for (let i = 0; i < this.tableDataActiveCategory.length; i++) {
				this.tableDataActiveCategory[i].active = false;
			}
			this.tableDataActiveCategory[idx].active = true;
			this.current_category_index = idx;
			this.current_category_item = item;
			this.category_name = new Array(item);
			this.get_active_catagory_details(new Array(item), "2");
		},
		hide_tab() {
			this.show_add_form = true;
		},
		// getQuestionsOfForm(item, idx) {
		// 	this.showing_index = false;
		// 	this.current_question_idx = idx;
		// 	this.isloading = true;
		// 	this.formDetails = item;
		// 	this.preview_formItemArray = [];
		// 	this.preview_formItemArray1 = [];

		// 	let params = {
		// 		location: this.locations,
		// 		form: item.form_info.id,
		// 		date: moment(this.active_date).format("YYYY-MM-DD"),
		// 		form_execution: item.id,
		// 	};
		// 	formBuilderServices.listQuestionsOfForms(params).then((res) => {
		// 		let response = JSON.parse(res.data);
		// 		this.Question_form_Details = response.form;
		// 		if (response.que_with_section.length != 0) {
		// 			this.preview_formItemArray = response.que_with_section;

		// 			this.preview_formItemArray[0].que_list.sort(
		// 				(a, b) =>
		// 					a.form_question_info.serial_no - b.form_question_info.serial_no
		// 			);
		// 		}
		// 		if (response.que_without_section.length != 0) {
		// 			this.preview_formItemArray = response.que_without_section;
		// 			this.preview_formItemArray.sort(
		// 				(a, b) =>
		// 					a.form_question_info.serial_no - b.form_question_info.serial_no
		// 			);
		// 		}
		// 		if (response.que_without_section.length != 0) {
		// 			this.preview_formItemArray.forEach((el) => {
		// 				if (el.child_form_question_execution_list.length != 0) {
		// 					el.form_question_info.dependent_inputType =
		// 						el.child_form_question_execution_list[0].form_question_info.input_type_info.name;
		// 					el.form_question_info.dependent_name =
		// 						el.child_form_question_execution_list[0].form_question_info.name;
		// 				}
		// 				el.form_question_info.expanded = false;
		// 				el.form_question_info.default = false;
		// 				el.button_yes = null;
		// 				el.button_no = null;
		// 				el.green_color = "";
		// 				el.red_color = "";
		// 			});
		// 			this.active_view = "VIEW_QUESTIONS";
		// 			this.show_active_project = false;
		// 			this.show_type = "1";
		// 			this.showing_index = true;
		// 			this.isloading = false;
		// 		} else {
		// 			this.active_view = "VIEW_QUESTIONS_SECTION";
		// 			this.show_active_project = false;
		// 			this.show_type = "2";
		// 			this.showing_index = true;
		// 			this.isloading = false;
		// 		}
		// 		//  let preview_formItemArray1 = this.preview_formItemArray;
		// 		 this.preview_formItemArray1 =JSON.parse(JSON.stringify(this.preview_formItemArray));
		// 		 console.log(this.preview_formItemArray1,'this.preview_formItemArray123')
		// 	});
		// },
		async getQuestionsOfForm(item, idx) {
			this.showing_index = false;
			this.current_question_idx = idx;
			this.isloading = true;
			this.formDetails = item;
			this.preview_formItemArray = []; // Reset to empty array
			this.preview_formItemArray1 = []; // Reset to empty array

			let params = {
				location: this.locations,
				form: item.form_info.id,
				date: moment(this.active_date).format("YYYY-MM-DD"),
				form_execution: item.id,
			};

			try {
				const res = await formBuilderServices.listQuestionsOfForms(params);
				let response = JSON.parse(res.data);
				this.Question_form_Details = response.form;
				console.log(response, "response");
				this.formItemObject = response;
				// if (response.que_with_section.length !== 0) {
				// 	this.preview_formItemArray = response.que_with_section;
				// 	this.preview_formItemArray[0].que_list.sort(
				// 		(a, b) =>
				// 			a.form_question_info.serial_no - b.form_question_info.serial_no
				// 	);
				// } else if (response.que_without_section.length !== 0) {
				// 	this.preview_formItemArray = response.que_without_section;
				// 	this.preview_formItemArray.sort(
				// 		(a, b) =>
				// 			a.form_question_info.serial_no - b.form_question_info.serial_no
				// 	);

				// }

				// this.preview_formItemArray.forEach((el) => {

				// 	if (el.child_form_question_execution_list.length !== 0) {
				// 		el.form_question_info.dependent_inputType =
				// 			el.child_form_question_execution_list[0].form_question_info.input_type_info.name;
				// 		el.form_question_info.dependent_name =
				// 			el.child_form_question_execution_list[0].form_question_info.name;
				// 	}
				// 	el.form_question_info.expanded = false;
				// 	el.form_question_info.default = false;
				// 	el.button_yes = null;
				// 	el.button_no = null;
				// 	el.green_color = "";
				// 	el.red_color = "";
				// });
				// console.log(this.preview_formItemArray1, 'this.preview_formItemArray1');
			} catch (error) {
				console.error("Error fetching questions:", error);
			} finally {
				// setTimeout(() => {
				// 	this.active_view =
				// 		this.preview_formItemArray.length !== 0
				// 			? "VIEW_QUESTIONS"
				// 			: "VIEW_QUESTIONS_SECTION";
				// }, 100);
				// this.show_type = this.preview_formItemArray.length !== 0 ? "1" : "2";
				// this.showing_index = true;
				this.isloading = false;
				this.show_active_project = false;
				setTimeout(() => {
					this.active_view = "VIEW_QUESTIONS_DETAILS";
				}, 100);
				this.$forceUpdate();
			}
		},
		list_all_locations(type, val) {
			this.locationItems = [];
			this.isloading = true;
			formBuilderServices.listAllLocations().then((res) => {
				this.locationItems = JSON.parse(res.data);
				this.locationItems = this.locationItems.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
				let current_date = moment(new Date()).format("YYYY-MM-DD");
				if (
					Object.keys(this.$route.query).length &&
					this.$route.query.outlet_id
				) {
					this.locations = this.$route.query.outlet_id;
					let params = {
						location: this.$route.query.outlet_id,
						date: current_date,
						execution_type: type,
					};
					this.list_active_projects(params, type, val);
				} else {
					this.locations = this.locationItems[0].id;
					let params = {
						location: this.locationItems[0].id,
						date: current_date,
						execution_type: type,
					};
					this.list_active_projects(params, type, val);
				}
				this.active_date = current_date;
			});
		},
		list_active_projects(params, type, val) {
			this.tableDataActive = [];
			this.tableDataActiveTask = [];
			formBuilderServices
				.listActiveProjects(params)
				.then((res) => {
					let response = JSON.parse(res.data).data;

					response.forEach((el) => {
						el.project_name = el.execution_setup_info.project_info.name;
						el.frequency = el.execution_setup_info.frequency;
					});
					response.sort(
						(a, b) =>
							a.execution_setup_info.project_info.serial_no -
							b.execution_setup_info.project_info.serial_no
					);
					this.tableDataActive = response;
					if (val == 1 && type == "project") {
						this.tableDataActiveTask = response;
						let obj = {};
						for (let i = 0; i < this.tableDataActive.length; i++) {
							if (this.tableDataActive[i].location_info.id == this.locations) {
								obj = this.tableDataActive[i];
							}
						}
						console.log("ob", obj);
						this.get_active_project_details(obj);
					} else {
						this.isloading = false;
					}
				})
				.catch(() => {
					this.isloading = false;
				});
		},
		list_manage_projects(type) {
			this.isloading = true;
			this.tableData = [];
			this.tableDataTask = [];
			formBuilderServices
				.listManageProjects(type)
				.then((res) => {
					if (type == "project") {
						this.tableData = JSON.parse(res.data);
					}
					if (type == "standalone") {
						this.tableDataTask = JSON.parse(res.data);
					}
					this.isloading = false;
					this.$forceUpdate();
				})
				.catch(() => {
					this.isloading = false;
				});
		},
		getLocationDetailsByLocationId(freq, location, date, obj) {
			const startDate = new Date();
			startDate.setHours(0, 0, 0, 0); // Set startDate to the start of the day
			const checkDate = new Date(this.active_date);
			checkDate.setHours(0, 0, 0, 0); // Set checkDate to the start of the day
			console.log(startDate, "startDate", checkDate, "checkDate");
			let showButtons = true; // Default to true, unless conditions below are met
			if (checkDate < startDate) {
				showButtons = false;
			}
			this.show_buttons = showButtons;
			console.log(
				freq,
				"freq",
				location,
				"location",
				date,
				"date",
				obj,
				this.show_buttons,
				"this.show_buttons"
			);
		},
		get_active_project_details(obj, condition, val, anyTimeApiId) {
			this.getLocationDetailsByLocationId(
				obj.frequency,
				obj.location_info.id,
				obj.end_date,
				obj
			);
			console.log(anyTimeApiId, "anyTimeApiId");
			this.quick_task = false;
			if (obj.execution_setup_info.execution_type == "standalone") {
				this.quick_task = true;
				val = "3";
			}
			this.isloading = true;
			this.tableDataActiveCategory = [];
			this.project_info_object = obj;
			this.project_info_name = obj.execution_setup_info.project_info.name;
			this.project_info_status =
				obj.task_status_update_info.status == "inprogress"
					? "In Progress"
					: "Completed";
			let params = {
				location: this.locations,
				date: moment(this.active_date).format("YYYY-MM-DD"),
				project: obj.execution_setup_info.project_info.id,
				project_execution:
					anyTimeApiId && anyTimeApiId.project_execution_id
						? anyTimeApiId.project_execution_id
						: obj.id,
			};
			formBuilderServices.activeProjectFormCategory(params).then((res) => {
				let response = JSON.parse(res.data).data;
				response.sort(
					(a, b) =>
						a.form_category_info.serial_no - b.form_category_info.serial_no
				);
				this.tableDataActiveCategory = response;
				this.tableDataActiveCategory.forEach((el) => {
					el.active = false;
					if (el.task_status_update_info.current_score == null) {
						el.task_status_update_info.current_score = 0;
					}
					if (
						el.task_status_update_info.current_score == 0 &&
						el.task_status_update_info.total_score == 0
					) {
						el.total_score = 0;
					} else {
						el.total_score =
							el.task_status_update_info.current_score /
							el.task_status_update_info.total_score;
					}
				});
				// this.tableDataActiveCategory[0].active = true;
				this.category_name = response;
				this.get_active_catagory_details(
					response,
					val == "5" ? "5" : val == "3" ? "3" : "1",
					condition
				);
			});
		},
		get_active_catagory_details(response, val, condition) {
			this.tableDataActiveSectionAbout = [];
			let params1 = {};
			if (condition == "0") {
				params1 = {
					location: this.locations,
					date: moment(this.active_date).format("YYYY-MM-DD"),
					form_category:
						this.tableDataActiveCategory[this.current_category_index]
							.form_category_info.id,
					form_category_execution:
						this.tableDataActiveCategory[this.current_category_index].id,
				};
			} else {
				params1 = {
					location: this.locations,
					date: moment(this.active_date).format("YYYY-MM-DD"),
					form_category: response[0].form_category_info.id,
					form_category_execution: response[0].id,
				};
				this.current_category_item = response[0];
				// this.current_category_index = 0;
			}

			formBuilderServices
				.listActiveProjectFormCategory(params1)
				.then((data) => {
					this.tableDataActiveSectionAbout = JSON.parse(data.data).data;

					if (val == "1") {
						this.tableDataActiveCategory[
							this.current_category_index
						].active = true;
					}
					if (val == "5") {
						this.tableDataActiveCategory[0].active = true;
						this.$forceUpdate();
					}
					if (val == "3") {
						this.getQuestionsOfForm(this.tableDataActiveSectionAbout[0], 0);
					}
					this.tableDataActiveSectionAbout.sort(
						(a, b) => a.form_info.serial_no - b.form_info.serial_no
					);

					this.show_active_project = true;
					this.isloading = false;
					this.$forceUpdate();
				});
		},
		changeProjectPage(idx) {
			for (let i = 0; i < this.projectPagesItems.length; i++) {
				this.projectPagesItems[i].active = false;
			}
			this.projectPagesItems[idx].active = true;
		},
		changeTaskPage(idx) {
			for (let i = 0; i < this.taskPagesItems.length; i++) {
				this.taskPagesItems[i].active = false;
			}
			this.taskPagesItems[idx].active = true;
		},
		changeChildPage(idx, item) {
			for (let i = 0; i < this.childPagesItems.length; i++) {
				this.childPagesItems[i].active = false;
			}
			this.childPagesItems[idx].active = true;
			if (item.name == "Tasks") {
				this.active_view = "TASK";
			}
			if (item.name == "Action") {
				this.active_view = "Action";
			}
			if (item.name == "Projects & Tasks") {
				this.active_view = "PROJECT";
			}
			if (item.name == "Forms") {
				this.active_view = "FORM";
			}
			if (item.name == "Dashboard") {
				this.active_view = "DASHBOARD";
			}
			this.changeTaskPage(0);
		},
		create_project() {
			this.storeObj = {};
			this.storeObj.action = "CREATE";
			this.active_view = "CREATE_PROJECT";
			this.visible = false;
		},
		create_task() {
			this.storeObj = {};
			this.storeObj.action = "CREATE";
			this.active_view = "CREATE_TASK";
			this.visible = false;
		},
		show_create_task_page() {
			this.task_category = null;
			this.due_date = null;
			this.start_date = null;
			this.task_designation = null;
			this.task_locations = null;
			this.task_form = null;
			this.task_edit = false;
			this.showCreateTaskPage = true;
			this.$validator.reset();
		},
	},
};
</script>

<style lang="scss">
.child_pages {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.project-table {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow: hidden;
			position: relative;
			text-align: left !important;
		}
	}

	.project-table-category {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
		}
		.el-table__body-wrapper {
			overflow: hidden;
			position: relative;
		}
	}
	.project-table-category5 {
		tbody tr td {
			text-align: left !important;
		}
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 52vh;
			max-height: 52vh;
		}
	}
	.project-table-category55 {
		tbody tr td {
			text-align: left !important;
		}
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow: hidden;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
}
.child_pages .project-table .el-table__body-wrapper {
	overflow-y: auto;
	min-height: 51vh;
	max-height: 51vh;
}
.input-class .el-input__inner {
	background: #ffffff;
	border-radius: 12px;
	padding-left: 25px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
}
.button-class {
	position: absolute;
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
}
.date .el-input__inner {
	border-radius: 12px;
}
.el-select.select {
	border-radius: 12px !important;
	width: 100%;
}
.el-select.select .el-input {
	border-radius: 12px !important;
	width: 100%;
}
.el-select.select .el-input .el-input__inner {
	border-radius: 12px !important;
	width: 100%;
}
.el-popover {
	max-height: 300px;
	overflow-y: auto;
}
.popover-menu {
	list-style-type: none;
	text-align: center;
	padding: 0;
	margin: 0;
}

.popover-menu li {
	cursor: pointer;
	height: 30px;
	line-height: 30px; /* Center vertically */
	/* Background color */
	border-bottom: 1px solid #ccc; /* Bottom border */
}

.popover-menu li:hover {
	background-color: #e0e0e0; /* Hover background color */
}

.popover-menu li:last-child {
	border-bottom: none; /* Remove bottom border from last item */
}
.button-class-2 {
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #fff;
}
</style>
